import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.682 15.682" {...props}><path id="svg220__Path_4404" data-name="Path 4404" d="M19.841 964.362a1.032 1.032 0 00-1.032 1.032v5.778h-5.777a1.032 1.032 0 000 2.063h5.778v5.778a1.032 1.032 0 102.063 0v-5.778h5.778a1.032 1.032 0 000-2.063h-5.778v-5.778a1.032 1.032 0 00-1.032-1.032z" transform="translate(-12 -964.362)" fill="currentcolor" /></svg>);